export const educationData = [
    {
        id: 1,
        institution: 'Federal University of Technology Minna',
        course: 'BTECH, Computer Science',
        startYear: '2022',
        endYear: '2026'
    },
    {
        id: 2,
        institution: 'Vocational Enterprise Institute of Technology',
        course: 'High School',
        startYear: '2015',
        endYear: '2018'
    }
]